import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterfaceService } from '@app/interfaces';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService extends InterfaceService {

    constructor(private http: HttpClient) {
        super();
    }

    createPrivateApplication(applicationName: string, description: string): Observable<any> {
        const payload = {
            applicationName,
            description
        };
        return this.http.post(
            this.getApiUrl('createPrivateApplications'),
            payload
        );
    }

    getPrivateApplications(page?: number, limit?: number,nameContains?: string): Observable<any> {
        const queryParams = {
            page: page,
            limit: limit,
            name_contains: nameContains
        };
        return this.http.get(
            this.getApiUrl('listPrivateApplications', queryParams)
        );
    }

    getApplicationScopes(privateApplicationId: any,showScopes?: string,nameContains?: string): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        if(nameContains){
            queryParams.name_contains = nameContains;
        }

        if (showScopes) {
            queryParams.showScopes = showScopes;
        }

        return this.http.get(
            this.getApiUrl('getApplicationScopes', queryParams)
        );
    }

    getApplicationScopesListing(privateApplicationId: any,name_contains?: any,page?: number, limit?: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId,
        };

        if (name_contains) {
            queryParams.name_contains = name_contains;
        }

        if (page) {
            queryParams.page = page;
        }

        if (limit) {
            queryParams.limit = limit;
        }

        return this.http.get(
            this.getApiUrl('getApplicationScopes', queryParams)
        );
    }

    updateApplicationScopes(privateApplicationId: number,scopes: string[]): Observable<any> {

        const payload = {
            // applicationId: privateApplicationId,
            scopes: scopes
        };

        return this.http.put(
            `${this.getApiUrl('updateApplicationScopes')}?applicationId=${privateApplicationId}`,
            payload
        );
    }

    updateApplicationWebhook(
        privateApplicationId: number,
        setupWebhooks: string,
        webhookUrl: string,
        webhookFailureEmail: string,
        scopes: string[] = []
    ): Observable<any> {

        const payload = {
            setupWebhooks,
            webhookUrl,
            webhookFailureEmail,
            scopes
        };

        return this.http.put(
            `${this.getApiUrl('updateApplicationWebhook')}?privateApplicationId=${privateApplicationId}`,
            payload
        );
    }

    getApplicationKeys(
        privateApplicationId: number,
        webhookId?: number
    ): Observable<any> {

        const queryParams = {
            privateApplicationId,
            webhookId
        };

        return this.http.get(
            this.getApiUrl('getApplicationKeys', queryParams)
        );
    }

    deletePrivateApplication(privateApplicationId: number): Observable<any> {
        return this.http.delete(
            `${this.getApiUrl('deletePrivateApplcation')}?privateApplicationId=${privateApplicationId}`
        );
    }

    deleteApplicationScopes(
        privateApplicationId: number,
        scope: string
    ): Observable<any> {

        return this.http.request(
            'delete',
            `${this.getApiUrl('deleteApplicationScopes')}?privateApplicationId=${privateApplicationId}`,
            {
                body: {
                    scope: scope
                }
            }
        );
    }

    getApplicationWebhook(privateApplicationId: any): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('getApplicationWebhook', queryParams)
        );
    }

    getWebhookScopes(privateApplicationId: any, showScopes?: string): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        if (showScopes) {
            queryParams.showScopes = showScopes;
        }

        return this.http.get(
            this.getApiUrl('getWebhookScopes', queryParams)
        );
    }

    updatePrivateApplication(
        privateApplicationId: number,
        applicationName: string,
        description: string
    ): Observable<any> {

        const payload = {
            applicationName,
            description
        };

        return this.http.put(
            `${this.getApiUrl('editPrivateApplication')}?privateApplicationId=${privateApplicationId}`,
            payload
        );
    }

    getPrivateApplicationById(privateApplicationId: any): Observable<any> {

        const params = new HttpParams().set('privateApplicationId', privateApplicationId.toString());

        return this.http.get(
            this.getApiUrl('listPrivateApplicationById'),
            { params }
        );
    }

    regenerateApplicationKey(privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.put(
            this.getApiUrl('regenerateApplicationKey', queryParams),
            {}
        );
    }

    regenerateWebhookSecret(privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.put(
            this.getApiUrl('regenerateWebhookSecret', queryParams),
            {}
        );
    }

    getApiLogs(params?: {
        privateApplicationId: number;
        limit?: number;
        page?: number;
        searchText?: string;
        filters?: any[];
    }) {
        let httpParams = new HttpParams();

        // Required query parameter
        httpParams = httpParams.set(
            'privateApplicationId',
            params.privateApplicationId.toString()
        );

        // Optional query parameters
        if (params.limit !== undefined) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }

        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }

        if (params.searchText) {
            httpParams = httpParams.set('searchText', params.searchText);
        }

        // Filters go in the request body
        const body: any = {};
        if (params.filters.length) {
            body.filters = params.filters;
        }

        return this.http.post(
            this.getApiUrl('getApiLogs'),
            body,
            { params: httpParams }
        );
    }

    getApilogFilterAction(): Observable<any> {
        const url = 'getApilogFilterAction';
        return this.http.get(this.getApiUrl(url));
    }

    getWebhookLogs(params?: {
        privateApplicationId: number;
        limit?: number;
        page?: number;
        searchText?: string;
        filters?: any[];
    }) {
        let httpParams = new HttpParams();

        // Required query parameter
        httpParams = httpParams.set(
            'privateApplicationId',
            params.privateApplicationId.toString()
        );

        // Optional query parameters
        if (params.limit !== undefined) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }

        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }

        if (params.searchText) {
            httpParams = httpParams.set('searchText', params.searchText);
        }

        // Filters go in the request body
        const body: any = {};
        if (params.filters.length) {
            body.filters = params.filters;
        }

        return this.http.post(
            this.getApiUrl('getWebhookLogs'),
            body,
            { params: httpParams }
        );
    }

    getWebhooklogFilterAction(): Observable<any> {
        const url = 'getWebhooklogFilterAction';
        return this.http.get(this.getApiUrl(url));
    }

    getApiLogDetails(apiLogId: number,privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            apiLogId,
            privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('getApiLogDetails', queryParams)
        );
    }

    getWebhookLogDetails(webhookLogId: number,privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            webhookLogId,
            privateApplicationId

        };

        return this.http.get(
            this.getApiUrl('getWebhookLogDetails', queryParams)
        );
    }

    getApplicationOverviewGraph(privateApplicationId: number): Observable<any> {
        const queryParams = {
            privateApplicationId: privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('getApplicationOverviewGraph', queryParams)
        );
    }

    getRecentErrors(privateApplicationId: number): Observable<any> {
        const queryParams = {
            privateApplicationId: privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('getRecentErrors', queryParams)
        );
    }

    resendWebhookCall(webhookLogId: number, privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            webhookLogId,
            privateApplicationId
        };

        return this.http.post(
            this.getApiUrl('resendWebhookCall', queryParams),
            {}
        );
    }

    validateApplicationOwner(privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('validateApplicationOwner', queryParams)
        );
    }

    takeApplicationOwnership(privateApplicationId: number, newUserId: number): Observable<any> {

        const body = {
            privateApplicationId,
            newUserId
        };

        return this.http.post(
            this.getApiUrl('takeApplicationOwnership'),
            body
        );
    }

    getPermissions() {
        return this.http.get(this.getApiUrl('get_access_details'))
    }

    checkPausedWebhook(privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.get(
            this.getApiUrl('checkPausedWebhook', queryParams)
        );
    }

    revertPausedWebhook(privateApplicationId: number): Observable<any> {

        const queryParams: any = {
            privateApplicationId
        };

        return this.http.post(
            this.getApiUrl('revertPausedWebhook', queryParams),
            {}
        );
    }

}
